import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface ScrapReasonMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface ScrapReasonMst {
    id?:number;
    name:string;  
 
    createdBy:number;
    createdDate:Date;
    updatedBy:number;
    updatedDate:Date
    tenantId:any;
    branchId:any;
      
    parameters?: ScrapReasonMstParameter[];
    links?: any;
}

export abstract class ScrapReasonMstData { 
    abstract list(url: string): Observable<ScrapReasonMst[]>;
    abstract create(url: string,data: ScrapReasonMst): Observable<any>;
    abstract update(url: string,data: ScrapReasonMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
